export default (siteScopes, currentScopeId) => {
  return (
    siteScopes.find(siteScope => {
      return siteScope.scopeId === currentScopeId;
    }) ?? null
  );
};
